module.exports = __webpack_public_path__ + "img/facilityInfo_2_3.5550f351.jpg";